import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-show-contact-info',
  templateUrl: './show-contact-info.component.html',
  styleUrls: ['./show-contact-info.component.scss']
})
export class ShowContactInfoComponent implements OnInit {
  @Input() contactInfo: any;
  contactInfoForm: FormGroup;
  data: any;

  constructor(
    private activeModal: NgbActiveModal,
    private fb: FormBuilder
  ) {
  }

  ngOnInit(): void {
    this.data = this.contactInfo;
    this.createForm();
  }

  private createForm(): any {
    this.contactInfoForm = this.fb.group({
      id: [this.contactInfo.id],
      date: [this.contactInfo.date],
      document: [this.contactInfo.document],
      reniecName: [this.contactInfo.reniecName],
      channel: [this.contactInfo.channel],
      email: [this.contactInfo.email],
      phone: [this.contactInfo.phone],
      type: [this.contactInfo.type],
      hour: [this.contactInfo.hour],
      reference: [this.contactInfo.reference],
    });
  }

  onNoClick(): void {
    this.activeModal.close();
  }

}
